<template>
  <div class="app-version-tooltip">
    <div class="form-tooltip__title">
      Реферальный код:
    </div>
    <div v-for="item in items" :key="item.length" class="form-tooltip__item">
      {{ item }}
    </div>
  </div>
</template>

<script>
export default {
  name: "ReferralCodeTooltip",
  data() {
    return {
      items: [
        'может содержать латинские буквы',
        'может содержать цифры',
        'не должен быть меньше  6 символов',
        'не должен быть длиннее 10 символов',
      ]
    }
  }
}
</script>

<style scoped>

</style>
